module.exports = __webpack_public_path__ + "img/Icon-sidebar-schedule.b9183ff9.svg";